export const deleteRegionalItem = `mutation($model : DeleteItemRequest!){
    deleteRegionalItem(input : $model)
  }`
